import { render, staticRenderFns } from "./SGPgConfigs.vue?vue&type=template&id=eaec0f82"
import script from "./SGPgConfigs.vue?vue&type=script&lang=js"
export * from "./SGPgConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports